import { Input, Button, Form, Modal, Select } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { assignLanguage } from '../../utils/helpers';
const FeedBackModal = ({ visible, onCancel, props }) => {
    const { Option } = Select
    const language = useSelector(state => state?.languageReducer)
    const selectedLanguage = assignLanguage(language?.language)
    const onFinish = (values) => {
        console.log(values)
    }
    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            footer={null}
            className='feedback_modal_div'
            closeIcon={null}
        >
            <Form onFinish={onFinish}>
                <button onClick={onCancel} className='close_modal_icon'>
                    <CloseOutlined />
                </button>
                <h3 className='form_heading'>{selectedLanguage?.send_us_feedback_heading}</h3>
                <Form.Item className='contact_form_input' name="name" rules={[{ required: true, message: selectedLanguage?.txt_please_enter_your_name_message }]}>
                    <Input placeholder={selectedLanguage?.input_name_placeholder} />
                </Form.Item>
                <Form.Item className='contact_form_input' name="phone" rules={[{ required: true, message: selectedLanguage?.txt_please_enter_your_phone_number_message }]}>
                    <Input type="tel" placeholder={selectedLanguage?.input_phone_placeholder} />
                </Form.Item>
                <Form.Item className='contact_form_input' name="email" rules={[{ required: true, message: selectedLanguage?.txt_please_enter_your_email_message }, { type: 'email', message: selectedLanguage?.txt_please_enter_a_valid_email }]}>
                    <Input type="email" placeholder={selectedLanguage?.input_email_placeholder} />
                </Form.Item>
                <Form.Item className='contact_form_input' name="selectOption">
                    <Select
                        className='appointment-modal-select'
                        placeholder={selectedLanguage?.feedback_input_select_country_placeholder}
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        <Option className='appointment-modal-options' value="Pakistan">{selectedLanguage?.feedback_input_pakistan}</Option>
                        <Option className='appointment-modal-options' value="US">{selectedLanguage?.feedback_input_us}</Option>
                        <Option className='appointment-modal-options' value="UK">{selectedLanguage?.feedback_input_uk}</Option>
                    </Select>
                </Form.Item>
                <Form.Item className='contact_form_input' name="message">
                    <Input.TextArea style={{ maxHeight: 80 }} rows={4} placeholder={selectedLanguage?.feedback_text_area_place_holder} />
                </Form.Item>
                <Form.Item className='contact_form_input'>
                    <Button type="primary" htmlType="submit" className='contact_submit_btn'>{selectedLanguage?.txt_submit_req_button}</Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default FeedBackModal;
